// JsFromRoutes CacheKey 6ee575381454127f0ceb51b88b7b3d24
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  index: /* #__PURE__ */ definePathHelper('get', '/api/v1/meals'),
  show: /* #__PURE__ */ definePathHelper('get', '/api/v1/meals/:id'),
  addItem: /* #__PURE__ */ definePathHelper('post', '/api/v1/meals/add_item'),
  removeItem: /* #__PURE__ */ definePathHelper('delete', '/api/v1/meals/meal_items/:id'),
}
